const GravityFormsExpressAddress = require('./gravity-forms-melissa-express-address');
const GravityFormsGoogleRecaptcha = require('./gravity-forms-google-recaptcha');

(($) => {
    const $forms = $('.gform_wrapper > form');

    window.addEventListener('load', init);

    function init() {

        let thisIntervalRetry = 0;
        
        const thisInterval = setInterval(() => {
            if (thisIntervalRetry > 10) {
                clearInterval(thisInterval);
                return null;
            }

            if (window.grecaptcha && window.gforms_recaptcha_recaptcha_strings) {
                clearInterval(thisInterval);

                new GravityFormsGoogleRecaptcha({
                    grecaptcha: window.grecaptcha, 
                    config: window.gforms_recaptcha_recaptcha_strings
                });
            } else {
                thisIntervalRetry++;
                return null;
            }
        }, 500);
        
        $forms.each((index, form) => {
            const $form = $(form);

            if ($form.find('.gfield.melissa-street-address').length > 0) {
                new GravityFormsExpressAddress({ $form: $form });
            }
        });

        const params = new URLSearchParams(window.location.search);

        $('[data-gform-parameter]').each((i, el) => {
            const $field = $(el);
            const param = $field.attr('data-gform-parameter');
            const paramVal = params.get(param);
            if (paramVal) {
                $field.val(paramVal);
            }
        });
    }
})(jQuery);